import { render, staticRenderFns } from "./EventRegionsComponent.vue?vue&type=template&id=5f35d6fa&scoped=true"
import script from "./EventRegionsComponent.vue?vue&type=script&lang=js"
export * from "./EventRegionsComponent.vue?vue&type=script&lang=js"
import style0 from "./EventRegionsComponent.vue?vue&type=style&index=0&id=5f35d6fa&prod&lang=scss"
import style1 from "./EventRegionsComponent.vue?vue&type=style&index=1&id=5f35d6fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f35d6fa",
  null
  
)

export default component.exports